import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Quality furniture for your home at affordable prices. Expert craftsmanship with 25+ years of experience.</p>
            <div className="social-links">
              <a href="/" aria-label="Facebook">f</a>
              <a href="/" aria-label="Instagram">📷</a>
              <a href="/" aria-label="Twitter">🐦</a>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/services/repair">Repair Services</a></li>
              <li><a href="/custom-studio">Custom Studio</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <a href="tel:+918533964262">+91 8533964262</a>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <a href="mailto:alokfurnitures@gmail.com">alokfurnitures@gmail.com</a>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>Aligarh, UttarPradesh, India</span>
            </div>
            <div className="contact-item">
              <FaClock className="contact-icon" />
              <span>Mon - Sun: 11:00 AM - 9:00 PM</span>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="footer-map">
          <h3>Visit Our Showroom</h3>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d262.1098713611226!2d78.071065255374!3d27.886133867983038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3974a488cc349255%3A0x7f334e7bbde43651!2sAlok%20Electronics%20and%20Furniture!5e0!3m2!1sen!2sin!4v1767360364383!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Shop Location"
            ></iframe>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Alok Electronics and Furnitures. All rights reserved. | <a href="/privacy">Privacy Policy</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
